import CmsComponentButton from "@/helpers/editor/components/CmsComponentButton.js";
import CmsComponentText from "@/helpers/editor/components/CmsComponentText.js";
import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import {tr} from "@vue-components/helpers/I18nPluginHelper.js";
import {extractHtmlText} from "@vue-components/helpers/utils.js";

export default class CmsBlockButton extends CmsBlock {
    static typeDef = {
        name: `Button|Bouton`,
        glyph: `fas fa-rectangle-wide`,
        type: `button`,
        category: `base`,
        isParent: false
    }

    get displayName() {
        return extractHtmlText(tr(this.button.text), 24);
    }

    constructor(data, page) {
        // compatibility, init with inactive component
        if (data && !data.altButton)
            data.altButton = false;

        super(data, page);

        this.title = new CmsComponentText(this.title);
        this.subtitle = new CmsComponentText(this.subtitle);
        this.description = new CmsComponentText(this.description);

        this.button = new CmsComponentButton(this.button);
        this.altButton = new CmsComponentButton(this.altButton);

        if (!data) {
            this.title.initText({}, `h2`);
            this.title.active = false;

            this.subtitle.initText({}, `h4`);
            this.subtitle.active = false;

            this.description.initText({});
            this.description.active = false;

            this.altButton.active = false;
        }
    }
}
